/**
 * Default export.
 *
 * @param Vue
 */
export default (Vue) => {
  Vue.component('f-select-professional-agenda', () => import('./select-professional-agenda'))
  Vue.component('f-select-company-plan', () => import('./select-company-plan'))
  Vue.component('f-select-entities', () => import('./select-entity'))
  Vue.component('f-select-professional-schedules-times', () => import('./select-professional-schedules-times'))
  Vue.component('f-select-agenda-lock-type', () => import('./select-agenda-lock-types'))
  Vue.component('f-select-professional-covenant', () => import('./select-professional-covenant'))
  Vue.component('f-select-user', () => import('./select-user'))
}



// WEBPACK FOOTER //
// ./src/components/form/fields/professional/index.js